<template>
  <div class="feedback-container" @click="toFeedbackPage">
    <div class="content">
      <a-icon type="form" />
      <span class="text">反馈</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  data() {
    return {};
  },
  methods: {
    toFeedbackPage() {
      this.$router.push('/feedback');
    }
  }
};
</script>

<style lang="less" scoped>
.feedback-container {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 4px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: rgba(0, 0, 0, 0.65);

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.85);
  }

  .content {
    display: flex;
    align-items: center;

    .anticon {
      font-size: 18px;
      margin-right: 6px;
      transition: color 0.3s ease;
    }

    .text {
      font-size: 14px;
      font-weight: 500;
      line-height: 1;
      user-select: none;
    }
  }
}
</style>
